
































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class DataTable<T> extends Vue {
  @Prop()
  data!: T[];

  @Prop()
  headers!: unknown;

  @Prop({ default: 10 })
  pageSize!: number;

  @Prop({ default: 1 })
  pageNumber!: number;

  @Prop({ default: 10 })
  totalItemCount!: number;

  @Prop({ default: true })
    pagingEnabled!: boolean;

  @Prop({ default: false })
    singleExpand!: boolean;

    @Prop({ default: false })
    showExpand!: boolean;

  @Prop({
    default() {
      return [5, 10, 20, 50, 100, 150, 200];
    }
  })
  allowedPageSizes!: number[];

  private sortBy: string = '';

    private displayData: unknown[] = [];
    private expandData: unknown[] = [];

  private sortOrder: string[] | string = '';

  private get footerOption(): unknown {
    return {
      'items-per-page-options': this.allowedPageSizes
    };
  }

  private onSortChanged(sortBy: string | string[]): void {
    this.sortOrder = sortBy;
  }

  private onSortDescChanged(isDesc: boolean | boolean[]): void {
    let result: string | string[] = '';
    if (Array.isArray(this.sortOrder) && Array.isArray(isDesc)) {
      result = [];
      this.sortOrder.forEach((item: string, i: number) => {
        if (Array.isArray(result)) {
          let itemSort = item;
          if (!isDesc[i]) {
            itemSort = `${item}_desc`;
          }

          result.push(itemSort);
        }
      });
    } else {
      result = !isDesc ? `${this.sortOrder}_desc` : this.sortOrder;
    }

    this.$emit('sort-changed', result);
  }
}
